/**
 * Store links for the "get the orderYaa app" promo on the stores page.
 *
 * Trimmed for this repo: the marketing site's version also exports `APP_STORE_URL`,
 * `detectMobilePlatform()` and `storeUrlFor()`, which exist to drive the server-side /get-app
 * redirect (orderyaa.com/get-app). That flow lives on the marketing site and has no counterpart
 * here — the storefront only renders the Play badge and a static QR pointing at that marketing URL.
 */

/**
 * Play Store URL for the Android app — the PUBLIC listing. Anyone can install from this, unlike the
 * closed internal-test link it replaced, which only worked for testers on the allow-list.
 *
 * iOS has no App Store listing yet. When it ships, add the badge here and on the stores page.
 */
export const PLAY_STORE_URL: string | null =
  'https://play.google.com/store/apps/details?id=com.orderyaa.app';

/**
 * An Android phone or tablet's browser — where {@link PLAY_STORE_URL} opens the Play Store app.
 * Browser-only: call it after checking the platform.
 */
export function isAndroidBrowser(): boolean {
  return typeof navigator !== 'undefined' && /Android/i.test(navigator.userAgent);
}

/**
 * An iPhone or iPad — where there is no App Store listing yet, so nothing installable to offer.
 * iPadOS reports itself as a Mac, so a touch screen on "Macintosh" counts too. Browser-only.
 */
export function isIosDevice(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod/i.test(navigator.userAgent)
    || (/Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1);
}
